import React, { useState, useEffect } from 'react';
import { Select, MenuItem, FormControl, Typography } from '@mui/material';
import { toast } from 'react-toastify';
import { toCapitalized } from '../../../Utils/Capitalize';

const ManufacturerDropdown = ({ fetchManufacturers, onChange, setSelectedManufacturer, selectedManufacturer }) => {
  const [linkedCompanies, setLinkedCompanies] = useState([]);

  const GetManufacturers = async () => {
    const { data, message, error } = await fetchManufacturers();
    if (!error) {
        setLinkedCompanies(data);
        if (data.length > 0 ) {
            setSelectedManufacturer(data[0].manufacturer_id);
        }
    } else {
        toast.error(message);
    }
  };

  useEffect(() => {
    GetManufacturers();
  }, []);

  const handleChange = (event) => {
    const value = event.target.value;
    setSelectedManufacturer(value);
    if (onChange) {
      onChange(value);
    }
  };

  return (
    <React.Fragment>
      <Typography variant="labelS" sx={{ color: '#666', mb: 0.5 }}>
          Manufacturer
      </Typography>
      <FormControl fullWidth sx={{ mb: 2 }}>
        <Select
          value={selectedManufacturer}
          onChange={handleChange}
          size='small'
          disabled={linkedCompanies.length === 1}
        >
          {linkedCompanies.map((company) => (
            <MenuItem key={company.manufacturer_id} value={company.manufacturer_id}>
             {toCapitalized(company.manufacturer_name)}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </React.Fragment>
  );
};

export default ManufacturerDropdown;